import Environment from '../static/models/Environment';
import { demoEnvironment } from './environment-configs/demo';
import { prodEnvironment } from './environment-configs/prod';
import { testEnvironment } from './environment-configs/test';

export default function getEnvironment(): Environment {
    const activeEnvironment: string = process.env.REACT_APP_ENV;
    switch (activeEnvironment) {
        case 'testing':
            return process.env.REACT_APP_USE_LOCAL_BACKEND === 'true'
                ? { ...testEnvironment, efuneralGatewayBaseUrl: 'http://localhost:5001' }
                : testEnvironment;
        case 'demo':
            return demoEnvironment;
        case 'production':
            return prodEnvironment;
        default:
            throw new Error(`Environment configuration not found: ${activeEnvironment}`);
    }
}
